"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var _useScrollbarSize2 = _interopRequireDefault(require("./useScrollbarSize"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** React component to fire an event when the size of the scrollbar changes */
var ScrollbarSize = function ScrollbarSize(_ref) {
  var onChange = _ref.onChange;

  var _useScrollbarSize = (0, _useScrollbarSize2.default)(),
      height = _useScrollbarSize.height,
      width = _useScrollbarSize.width;

  (0, _react.useEffect)(function () {
    onChange({
      height: height,
      width: width
    });
  }, [height, width, onChange]);
  return null;
};

var _default = ScrollbarSize;
exports.default = _default;